import { LitElement, html, css } from "lit"

export class MyButton extends LitElement {
    static styles = css`
        button {
            border: none;
            color: white;
            cursor: pointer;
            transition: background-color 0.2s ease;
        }

        /* Types */
        .primary {
            background: var(--colors-primary-500, #6200ea);
        }
        .primary:hover {
            background-color: var(--color-primary-dark, #3700b3);
        }
        .primary:active {
            background-color: var(--color-primary-light, #bb86fc);
        }
        .primary:focus {
            background-color: var(--color-primary-dark, #3700b3);
        }

        .primary-gradient {
            background: var(--gradient, #6200ea);
        }
        .primary-gradient:hover {
            background-color: var(--color-primary-dark, #3700b3);
        }
        .primary-gradient:active {
            background-color: var(--color-primary-light, #bb86fc);
        }
        .primary-gradient:focus {
            background-color: var(--color-primary-dark, #3700b3);
        }

        .secondary {
            background-color: var(--colors-secondary-500, #03dac6);
        }
        .secondary:hover {
            background-color: var(--color-secondary-dark, #3700b3);
        }
        .secondary:active {
            background-color: var(--color-secondary-light, #bb86fc);
        }
        .secondary:focus {
            background-color: var(--color-secondary-dark, #3700b3);
        }

        .outline {
            background-color: transparent;
            border: 1px solid var(--color-primary, #6200ea);
            color: var(--color-primary, #6200ea);
        }
        .outline:hover {
            background-color: var(--color-primary-light, #bb86fc);
            color: white;
        }
        .outline:active {
            background-color: var(--color-primary-dark, #3700b3);
            color: white;
        }
        .outline:focus {
            background-color: var(--color-primary-dark, #3700b3);
            color: white;
        }

        .outline-white {
            background-color: transparent;
            border: 1px solid var(--color-white, #ffffff);
            color: var(--color-white, #ffffff);
        }
        .outline-white:hover {
            background-color: var(--color-primary-light, #bb86fc);
            color: white;
        }
        .outline-white:active {
            background-color: var(--color-primary-dark, #3700b3);
            color: white;
        }
        .outline-white:focus {
            background-color: var(--color-primary-dark, #3700b3);
            color: white;
        }

        /* Sizes */
        .small {
            font-size: var(--btn-font-small);
            padding: var(--btn-padding-small);
            border-radius: 4px;
        }
        .medium {
            font-size: var(--btn-font-medium);
            padding: var(--btn-padding-medium);
            border-radius: 6px;
            font-weight: bold;
        }
        .large {
            font-size: var(--btn-font-large);
            padding: var(--btn-padding-large);
            border-radius: 8px;
        }
    `

    static properties = {
        type: {type: String},
        size: {type: String}
    };

    constructor() {
        super();
        this.type = 'primary'; // default type
        this.size = 'medium'; // default size
    }

    render() {
        const classes = `${this.type} ${this.size}`
        return html`<button class=${classes}><slot></slot></button>`
    }
}

customElements.define('my-button', MyButton);